import React from 'react'
import './dashboard.css'
import ProfileNavbar from '../../../../components/Profile-navbar/profile-navbar'
import pic from '../../../../images/pic.svg'
import { recommendedJobs } from '../../../../data'
import favorite from '../../../../images/favorite.svg'
import DashboardAlert from './alert'
import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Card } from 'react-bootstrap'

const Dashboard = () => {
  return (
    <div>
        <ProfileNavbar/>
        <Container fluid className='dashboard-section p-5'>
          <DashboardAlert/>
          <div className='d-flex justify-content-between align-items-center'>
            <div className='dashboard-header mt-3'>
              <h4>Hello John</h4>
              <p>Welcome to your Dashboard! Find out what's happening.</p>
           </div>
           <img className='dashboard-img'src={pic}/>
          </div>
          <div className='apply-line'></div>
          <Row className='gap-4 mt-5 pt-2'>
            <Col  xs={12} lg={6} className=''>
            <h1 className=''>Recommended Jobs for You</h1>
            <Row className='mt-4 gap-3'>
            {recommendedJobs.map((jobs) => {
             const {id,
             image,
              role,
              company,                    amount,
              frequency,
              period,
              workMode,                  icon,
             } = jobs;
              return(                  <Card className='p-3 ' style={{  background: '#CCCCDD'}}>
                <Row className='align-items-center'>
                  <Col xs={4} sm={3} md={2} lg={3}xl={2}className=''>
                    <img className='' src={image} style={{width:'100px', height:'80px'}}/>
                  </Col>
                  <Col className='d-flex flex-column gap-2 mt-1 dashboard-recommend-details'>
                  
                    <h4>{role}</h4>
                    <h5>{company}</h5>

                    <div className='top-div'>
                      <button className='period-btn'>{period}</button>
                      <p> <img src={icon}/>{workMode}</p>
                    </div>
                    <h6>Salary Range: {amount}&nbsp;<span>({frequency})</span></h6>
                  
                  </Col>
                  <Col sm={3} className='d-flex flex-column gap-2 px-3'>
                 
                    <button className='dashboard-apply-btn'>Apply</button>
                    <button className='dashboard-save-btn'><img src={favorite}/>
                      Save
                     </button>
                  
                  </Col>
               
                
                </Row>
              </Card>
              )                    
              })}
            </Row>

            </Col>
            <Col >
              <Row className='gap-4'>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}className='py-3'>
                  <h4 className='card-head '>Your Profile</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='d-flex justify-content-between align-items-center py-3' >
                    <p className='card-p'>Unlock new features by completing your Profile</p>
                    <Link to='/jobseekerprofile'>
                    <FaArrowRight className='arrow-right'/>
                    </Link>
                    </Card.Text>
                  </Card.Body>

                </Card>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}className='py-3'>
                  <h4 className='card-head'>Assessments</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='d-flex justify-content-between align-items-center py-3' >
                    <p className='card-p'>You have 0 assessments. <br/>Take IQ tests to improve your skills and earn a badge</p>
                    <Link to='/assessments'>
                    <FaArrowRight className='arrow-right'/>
                    </Link>
                    </Card.Text>
                  </Card.Body>

                </Card>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}className='py-3'>
                  <h4 className='card-head'>Your Notifications</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='d-flex justify-content-between align-items-center py-3' >
                    <p className='card-p'> You have no Notifications Yet</p>
                    <Link to='/notifications'>
                    <FaArrowRight className='arrow-right'/>
                    </Link>
                    </Card.Text>
                  </Card.Body>

                </Card>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}className='py-3'>
                  <h4 className='card-head'>Your Job Alerts</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='d-block d-sm-flex justify-content-between align-items-center py-3 ' >
                    <p className='card-p'>You have no job alerts to notify you when jobs match your search</p>
                    <div className='d-flex justify-content-center 
                    align-items-center text-center '>
                    <Link to='/jobalert' className=' dashboard-alert-btn text-decoration-none'>
                    Create Job Alert
                  </Link>
                  </div>
                    </Card.Text>
                  </Card.Body>

                </Card>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}>
                  <h4 className='card-head'>Boost Your Career</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='d-flex justify-content-between align-items-center py-3' >
                    <div className='card-p  flex-column'>
                  <a href='#'>Check out our latest job articles and get job interview tips</a>
                  <br/> <br/>
                  <a href='#'>Join our trainings and webinars today</a>
                </div>
                    </Card.Text>
                  </Card.Body>

                </Card>
              </Row>

            </Col>
          </Row>
          
        </Container>
      
    </div>
  )
}

export default Dashboard
